exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-ai-project-assistant-input-shortcut__icon[data-v-d4678ab6]{border-radius:4px}.yxtbiz-ai-project-assistant-input-shortcut__icon[data-v-d4678ab6]:hover{background-color:#f5f5f5}\n", ""]);

